module.exports = __webpack_public_path__ + "static/media/brojohn.9cfbc733.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/brojohn.png
// module id = 88
// module chunks = 0